export default __webpack_public_path__ + "static/media/shoe-icon.da15e814.svg";